import { render } from "./ImageNews.vue?vue&type=template&id=0a40ab5f&scoped=true"
import script from "./ImageNews.vue?vue&type=script&lang=js"
export * from "./ImageNews.vue?vue&type=script&lang=js"

import "./ImageNews.vue?vue&type=style&index=0&id=0a40ab5f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a40ab5f"]])

export default __exports__